var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{attrs:{"id":_vm.modalId,"title":"Add a Recurring Work Order"},on:{"on-hide":_vm.resetFormData}},[_c('recurring-work-order-form',{key:_vm.formKey,attrs:{"location_id":_vm.locationId,"client":_vm.client,"client_id":_vm.client?.id},on:{"on-submit":_vm.create,"on-save":_vm.onSave,"on-cancel":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }